/**
 * @fileoverview Agent definition for world-system-snapshotter-v3.
 *
 * @category world-building.systems.snapshots
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-system-snapshotter-v3',
  kind: 'primitive',
  name: 'World System Snapshotter',
  description: 'Updates a world system state after a chapter, creating a point-in-time snapshot.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.systems.snapshots',
    usedBy: ['use-world-system-snapshotter-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-system-details-generator-v3'],
  },
};
